import { Api } from 'utils';

class GlobalNotificationService {
	
	static send = async (params?: any) => Api.createResponse('superadmin/global-notifications/send',params);
	
}

export default GlobalNotificationService;